export default __webpack_public_path__ + "static/media/loading.46c884f8.gif";